// Portuguese translations
const pt = {
    // App Header
    appTitle: "CLIA Analytics",

    // Language selector
    language: "Idioma",
    english: "Ingles",
    spanish: "Espanhol",
    portuguese: "Portugues",

    // Sidebar Menu
    menu: {
        home: "Inicio",
        mediaMonitoring: "Monitoramento de Midia",
        priceMonitor: "Monitor de Precos",
        priceAlerts: "Alertas de Precos",
        opportunities: "Oportunidades Comerciais",
        chat: "Conversas",
        aiAssistant: "CLIA Agent",
        newChat: "Nova consulta",
        reports: "Relatorios",
        analytics: "Analises",
        admin: "Admin",
        administration: "Painel de Administracao",
        settings: "Configuracoes",
        help: "Ajuda",
        faq: "Perguntas Frequentes",
        guide: "Consultas sugeridas",
        contact: "Contato",
        terms: "Termos e Condicoes",
        logout: "Sair",
        moduleDisabled: "Este modulo nao esta disponivel para sua conta",
        recentChats: "Chats Recentes",
        noChats: "Nao ha conversas",
        savedQueries: "Consultas Salvas",
        noSavedQueries: "Nao ha consultas salvas",
        customReports: "Relatórios Personalizados",
        newReport: "Novo relatório",
        noReports: "Sem relatórios ainda",
        deleteReport: "Excluir este relatório?",
        dataDictionary: "Dicionario de Dados",
        uploadedFiles: "Arquivos Enviados",
        uploadFile: "Enviar Arquivo",
        noFiles: "Nao ha arquivos enviados",
        confirmDelete: "Confirmar exclusao",
        deleteConversation: "Deseja excluir esta conversa?",
        deleteSavedQuery: "Deseja excluir esta consulta salva?",
        agentMemory: "Memoria do Agente",
        agentMemoryTitle: "Instrucoes Personalizadas",
        agentMemoryDescription: "Escreva instrucoes que o agente lembrara em todas as suas conversas. Por exemplo: preferencias, contexto do seu negocio, formato de respostas, etc.",
        agentMemoryPlaceholder: "Exemplo:\n- Sempre responda em portugues\n- Trabalho no setor farmaceutico\n- Prefiro ver precos em BRL\n- Meus principais concorrentes sao: Drogasil, Raia, Pacheco",
        agentMemoryTip: "Voce tambem pode usar '/lembra' no chat para que o agente adicione informacoes automaticamente.",
        goToAdmin: "Ir ao Painel de Administracao",
        interactiveGuide: "Guia Interativo",
        editTitle: "Editar titulo",
        noDictionary: "Nenhum dicionário configurado",
        uploading: "Enviando...",
        deleteFile: "Excluir arquivo",
        fileTooLarge: "O arquivo é muito grande. Máximo 15MB",
        saveError: "Erro ao salvar",
        saveMemoryError: "Erro ao salvar a memória",
        comingSoon: "Em breve",
        badgeNew: "Novo",
        roleAdmin: "Administrador",
        roleUser: "Usuário",
        // Secciones del sidebar
        sectionSocial: "Social Media",
        sectionAdvertising: "Publicidade",
        sectionCommercial: "Comercial",
        sectionWebMedia: "Web e Mídia",
        // Items del sidebar
        socialMonitoring: "Monitoramento de Redes",
        instagramOrganic: "Instagram Orgânico",
        facebookOrganic: "Facebook Orgânico",
        tiktokOrganic: "TikTok Orgânico",
        digitalCampaigns: "Campanhas Digitais",
        campaignsApi: "Campanhas (API)",
        tiktokCampaigns: "Campanhas TikTok",
        sales: "Vendas",
        benefits: "Benefícios Cantabria",
        andromedapp: "AndromedApp",
        webTraffic: "Tráfego Web",
        news: "Notícias",
        aiInsights: "AI Insights",
        integrations: "Integrações",
        users: "Usuários",
        organicSocial: "Redes Orgânicas"
    },

    // Homepage - Media Monitoring
    homepage: {
        title: "Monitoramento de Midia",
        subtitle: "Configure suas palavras-chave para monitorar noticias relevantes",
        configureKeywords: "Configurar Palavras-chave",
        update: "Atualizar",
        searching: "Buscando...",
        customize: "Personalizar",
        country: "Pais das noticias",
        countryHint: "Altere o pais de busca. As noticias serao recarregadas automaticamente.",

        // Tabs
        tabNews: "Noticias",
        tabSaved: "Destacadas",
        savedTitle: "Noticias Destacadas",

        // TikTok
        tiktokTitle: "Posts do TikTok",
        tiktokRefresh: "Atualizar TikTok",
        tiktokSearching: "Buscando...",
        tiktokPendingTitle: "Buscando posts no TikTok…",
        tiktokPendingHint: "Isso pode levar 3-8 minutos. Voce pode navegar para outra aba enquanto isso.",
        tiktokStartedAt: "Iniciado em",
        tiktokLastFetched: "Ultima atualizacao:",
        tiktokEmpty: "Sem posts ainda. Pressione Atualizar para iniciar a busca.",
        tiktokEmptyNoKeywords: "Adicione palavras-chave primeiro — TikTok usa as mesmas palavras das noticias.",
        savedTiktoksHeader: "TikToks destacados",
        tiktokSortLabel: "Ordenar por",
        tiktokSortViews: "Mais vistos",
        tiktokSortRecent: "Mais recentes",
        tiktokSortOldest: "Mais antigos",
        tiktokSortLikes: "Mais curtidos",
        tiktokSortComments: "Mais comentados",
        // Idade relativa
        agoPrefix: "Ha",
        monthAgo: "mes",
        monthsAgo: "meses",
        yearAgo: "ano",
        yearsAgo: "anos",

        // Modal de comentarios
        commentsTitle: "Comentarios",
        commentsClose: "Fechar",
        commentsViewOnTiktok: "Ver no TikTok",
        commentsLoadButton: "Carregar comentarios",
        commentsConfirmCount: "Este post tem {count} comentarios.",
        commentsCap: "Vamos guardar ate {cap} comentarios (top por curtidas).",
        commentsCapExceeded: "Post excede {cap}. Vamos guardar apenas os top {cap} por curtidas.",
        commentsPending: "Buscando comentarios... Pode levar 3-8 minutos.",
        commentsRetry: "Tentar novamente",
        commentsErrorGeneric: "Nao foi possivel carregar os comentarios.",
        commentsErrorNetwork: "Erro de rede ao carregar comentarios.",
        commentsEmpty: "Sem comentarios disponiveis.",
        commentsLoadedMeta: "{count} comentarios carregados · {when}",
        commentsViewThread: "Ver {count} respostas no TikTok",

        // Analise de sentimentos
        sentimentTitle: "Analise de sentimentos",
        sentimentCta: "Analisar sentimentos",
        sentimentAnalyzing: "Analisando...",
        sentimentReanalyze: "Re-analisar",
        sentimentThemes: "Temas principais",
        sentimentTopPositive: "Top positivo",
        sentimentTopNegative: "Top critico",
        sentimentErrorGeneric: "Nao foi possivel completar a analise.",
        sentimentErrorNetwork: "Erro de rede durante a analise.",

        // Keywords panel
        keywordsConfig: "Configuracao de Palavras-chave",
        keywordsConfigDesc: "Defina as palavras-chave para monitorar noticias",
        searchPlaceholder: "Digite uma palavra-chave e pressione Enter...",
        useIndustryTemplate: "Usar modelo por industria",
        activeKeywords: "Palavras-chave Ativas",
        resetDefault: "Padrao",
        clearAll: "Limpar",
        loadingKeywords: "Carregando palavras-chave...",
        noKeywordsConfigured: "Nao ha palavras-chave configuradas.",
        addKeywordsHint: "Adicione palavras-chave manualmente ou use um modelo.",
        lastSaved: "Ultimo salvo:",
        saveConfig: "Salvar Configuracao",
        saving: "Salvando...",
        keywordsLimitError: "Nao e possivel adicionar mais de 20 palavras-chave",
        keywordsLimitReached: "Limite de 20 palavras-chave atingido",
        confirmRestoreDefaults: "Restaurar as palavras-chave padrao da organizacao?",

        // Status bar
        news: "noticias",

        // News section
        relevantNews: "Noticias Relevantes",
        readArticle: "Ler artigo",
        noLink: "Sem link",
        priorityMedia: "Veículo prioritário",
        tabPriority: "Revistas",
        priorityNewsTitle: "Revistas selecionadas",
        today: "Hoje",
        yesterday: "Ontem",
        daysAgo: "dias atras",

        // Loading & empty states
        searchingNews: "Buscando noticias...",
        analyzingKeywords: "Analisando {count} palavras-chave",
        searchMayTake: "Isso pode levar 30-45 segundos",
        noNewsFound: "Nenhuma noticia encontrada",
        tryOtherKeywords: "Tente outras palavras-chave ou atualize mais tarde",
        searchNews: "Buscar noticias",

        // Presets
        presetsPharmaceutical: "Farmaceutica",
        presetsRetail: "Varejo",
        presetsTechnology: "Tecnologia",
        presetsFinance: "Financas"
    },

    // Alerts Page - Price Monitor
    alerts: {
        title: "Monitor de Precos",
        subtitle: "Alertas de mudanca de preco nos concorrentes",
        update: "Atualizar",
        info: "Informacao",

        // Config panel
        minThreshold: "Limite ± (%)",
        productsPerChain: "Produtos por rede",
        filterByUpcs: "Filtrar por UPCs",
        enabled: "Ativado",
        disabled: "Desativado",
        apply: "Aplicar",
        upcs: "UPCs",

        // Summary
        alerts: "alertas",
        changeGte: "variacao",
        upcFilterActive: "Filtro UPCs ativo",
        filterChannels: "Filtrar canais",

        // Product card
        previous: "Anterior:",
        current: "Atual:",
        viewHistory: "Ver historico",
        viewInStore: "Ver na loja",

        // History modal
        priceHistory: "Historico de Precos",
        priceEvolution: "Evolucao do preco",
        lastRecords: "Ultimos {count} registros",
        date: "Data",
        regularPrice: "Preco Regular",
        salePrice: "Preco Promocional",
        finalPrice: "Preco Final",
        currentPrice: "Preco atual",
        detectedChange: "Variacao detectada",

        // UPC Manager
        manageTrackedUpcs: "Gerenciar UPCs Monitorados",
        fileExists: "Arquivo existe com {count} UPCs",
        noTrackingFile: "Nao ha UPCs configurados. Adicione UPCs para comecar a monitorar.",
        currentUpcs: "UPCs atuais",
        clear: "Limpar",
        more: "mais",
        loadFromFile: "Carregar de arquivo",
        downloadTemplate: "Baixar modelo CSV",
        uploadFile: "Enviar arquivo CSV",
        orEnterManually: "Ou insira manualmente",
        upcsHint: "UPCs separados por virgula ou um por linha. Ao salvar, o arquivo no S3 sera atualizado.",
        cancel: "Cancelar",
        replaceAll: "Substituir tudo",
        addUpcs: "Adicionar UPCs",
        save: "Salvar",
        upcsStorageInfo: "Os UPCs salvos serao usados para filtrar alertas de preco. O limite aplica como variacao absoluta (± %).",

        // States
        analyzingPriceChanges: "Analisando mudancas de preco...",
        noPriceAlerts: "Nao ha alertas de preco",
        noChangesDetected: "Nao foram detectadas mudancas de preco maiores que {threshold}%",
        noChangesInTracked: "Nao foram detectadas mudancas de preco nos seus {count} UPCs monitorados",
        retry: "Tentar novamente",
        noHistoryAvailable: "Nao ha historico de precos disponivel",
        lastRecordedDate: "Data nao disponivel",
        noUpcsConfigured: "Nao ha UPCs configurados",
        viewAllProducts: "Ver todos os produtos",
        filterOnlyMyUpcs: "Filtrar apenas meus UPCs",
        clearAllUpcs: "Excluir todos os UPCs",
        replaceAllUpcs: "Substituir todos os UPCs existentes",

        // Info modal
        howToUse: "Como usar o Monitor de Precos",
        overviewTitle: "Visao geral",
        overviewDesc: "Mostra os produtos com maior variacao de preco por rede, util para detectar movimentos significativos no mercado.",
        filterByUpcsTitle: "Filtrar por UPCs",
        filterByUpcsDesc: "Ative o toggle 'Filtrar por UPCs' para ver apenas os produtos que voce configurou. Para adicionar UPCs:",
        filterStep1: "Clique no botao 'UPCs'",
        filterStep2: "Baixe o modelo CSV ou envie seu arquivo",
        filterStep3: "Os UPCs sao salvos na sua pasta",
        understood: "Entendido",

        // Sorting options
        sortBy: "Ordenar por",
        sortHighest: "Maior variacao",
        sortLowest: "Menor variacao",
        sortPositive: "Somente aumentos",
        sortNegative: "Somente reducoes",

        // Show all tracked UPCs
        showAllTracked: "Ver todos",
        showOnlyWithChanges: "Mostrar apenas UPCs com mudancas de preco",
        showAllTrackedUpcs: "Mostrar todos os UPCs prioritarios (com ou sem mudanca)",
        onlyChanges: "Com mudancas",

        // Channels
        selectChannels: "Selecionar canais",
        all: "Todos",
        none: "Nenhum",

        // Email notifications
        emailNotifications: "Notificacoes por e-mail",
        emailNotificationsEnable: "Ativar notificacoes por e-mail",
        emailNotificationsDisable: "Desativar notificacoes por e-mail"
    },

    // Chat
    chat: {
        title: "CLIA Agent",
        placeholder: "Pergunte sobre seus dados · Digite @ para arquivos · /lembre para treinar o agente",
        send: "Enviar",
        thinking: "Pensando...",
        error: "Ocorreu um erro. Por favor, tente novamente.",
        newConversation: "Nova conversa",
        clearChat: "Limpar chat",
        exportChat: "Exportar chat",
        disclaimer: "Embora eu analise dados rapidamente, a decisao final e sua. Minhas sugestoes sao apenas indicativas, revise cuidadosamente antes de agir.",

        // Suggested questions
        loadingSuggestions: "Gerando sugestoes...",
        suggestedQuestions: [
            "Quais sao os produtos com maiores vendas em unidades no ultimo mes?",
            "Quais categorias tem as melhores margens de lucro?",
            "Como nossos precos se comparam aos do mercado por categoria?"
        ],

        // Data table
        rows: "linhas",
        columns: "colunas",
        export: "Exportar",
        visualize: "Visualização avançada",
        chartModalTitle: "Visualização de dados",
        viewData: "Ver Dados",
        downloadExcel: "Baixar Excel",
        downloadCSV: "Baixar CSV",
        downloadPDF: "Baixar PDF",
        loadingData: "Carregando dados...",
        options: "Opcoes",
        saving: "Salvando...",
        saveQuery: "Salvar consulta",
        saveToReport: "Salvar no relatório",
        saveToReportTitle: "Salvar resposta no relatório",
        saveChartToReportTitle: "Salvar gráfico no relatório",
        createNewReportWithMessage: "Criar novo relatório com esta resposta",
        createNewReportWithChart: "Criar novo relatório com este gráfico",
        orAddToExisting: "ou adicionar a um existente:",
        loadingReports: "Carregando relatórios…",
        noReportsYet: "Você ainda não tem relatórios. Crie um acima.",
        blocksCount: "blocos",
        savedInReport: "Salvo em",
        view: "Ver",
        chart: "Grafico",
        download: "Baixar",
        generateChart: "Gerar grafico",
        downloadTableAsExcel: "Baixar tabela como Excel",

        // Chart
        chartType: "Tipo de grafico",
        bars: "Barras",
        lines: "Linhas",
        pie: "Pizza",
        doughnut: "Rosca",
        dataConfig: "Configuracao de dados",
        xAxis: "Eixo X (Categoria)",
        yAxis: "Eixo Y (Valor)",
        aggregation: "Agregacao",
        sum: "Soma",
        average: "Media",
        count: "Contagem",
        max: "Maximo",
        min: "Minimo",
        dataLimit: "Limite de dados",
        allData: "Todos",
        categories: "categorias",
        records: "registros"
    },

    // Admin
    admin: {
        title: "Painel de Administracao",
        back: "Voltar",
        users: "Usuarios",
        files: "Arquivos",
        guide: "Guia",
        plan: "Meu Plano",
        terms: "Termos",
        faq: "FAQ",
        integrations: "Integrações",
        plans: "Planos",

        // User manager
        usersTitle: "Usuarios da Organizacao",
        configureMyMFA: "Configurar meu MFA",
        totalUsers: "Total de Usuarios",
        active7Days: "Ativos (7 dias)",
        active30Days: "Ativos (30 dias)",
        administrators: "Administradores",
        searchUsers: "Buscar usuarios...",
        addUser: "Adicionar Usuario",
        editUser: "Editar Usuario",
        deleteUser: "Excluir Usuario",
        username: "Usuario",
        organization: "Organizacao",
        role: "Funcao",
        lastAccess: "Ultimo Acesso",
        pbiAccess: "Acessos PBI",
        messages: "Mensagens",
        registrationDate: "Registro",
        actions: "Acoes",
        loadingUsers: "Carregando usuarios...",
        noUsersInOrg: "Nao ha usuarios nesta organizacao",
        never: "Nunca",
        justNow: "Agora mesmo",
        minutesAgo: "min atras",
        hoursAgo: "h atras",
        yesterday: "Ontem",
        daysAgo: "dias atras",
        weeksAgo: "semanas atras",

        // Plan manager
        planTitle: "Plano e Uso Mensal",
        monthlyQueries: "Consultas do Mes (Organizacao)",
        used: "utilizado",
        remaining: "restantes",
        queries: "consultas",
        period: "Periodo",
        usersInOrg: "Usuarios",
        inOrg: "na org.",
        planDetails: "Detalhes do Plano",
        usersInOrganization: "Usuarios na organizacao",
        monthlyLimit: "Limite mensal",
        queriesUsedThisMonth: "Consultas usadas este mes",
        planNote: "O contador mostra as consultas de TODOS os usuarios da organizacao. Ele e reiniciado automaticamente no primeiro dia de cada mes.",
        orgExceededLimit: "A organizacao excedeu o limite mensal",
        queriesLeft: "consultas restantes para a organizacao",
        loadingPlan: "Carregando informacoes do plano...",
        noUsageData: "Nao ha dados de uso disponiveis",
        retry: "Tentar novamente",

        // File manager
        fileManagerTitle: "Gerenciador de Arquivos",
        filesCount: "arquivos",
        total: "total",
        searchFiles: "Buscar arquivos...",
        uploadFile: "Enviar Arquivo",
        fileName: "Nome do Arquivo",
        fileType: "Tipo",
        size: "Tamanho",
        uploadedBy: "Enviado Por",
        uploadDate: "Data de Envio",
        download: "Baixar",
        delete: "Excluir",
        noPermission: "Voce nao tem permissao para ver arquivos",
        errorLoadingFiles: "Erro ao carregar arquivos",
        fileTypeNotAllowed: "Tipo de arquivo nao permitido. Use CSV, Excel, PDF ou imagens.",
        fileSizeExceeded: "O arquivo excede o limite de 500 MB por arquivo",
        uploading: "Enviando...",
        fileUploadedSuccess: "Arquivo enviado com sucesso",
        errorUploadingFile: "Erro ao enviar arquivo",
        connectionError: "Erro de conexao ao enviar arquivo",
        errorDownloading: "Erro ao gerar link de download",
        errorDeleting: "Erro ao excluir arquivo",
        fileDeletedSuccess: "Arquivo excluido com sucesso",
        dragDropHint: "Arraste arquivos aqui ou clique para selecionar",
        fileTypesHint: "CSV, Excel, PDF, Imagens (max 500MB por arquivo)",
        loadingFiles: "Carregando arquivos...",
        noFilesUploaded: "Nao ha arquivos enviados",
        uploadFirstFile: "Envie seu primeiro arquivo usando a area acima",
        file: "Arquivo",
        type: "Tipo",
        uploaded: "Enviado",
        confirmDelete: "Confirmar exclusao",
        confirmDeleteMessage: "Tem certeza de que deseja excluir",
        cancel: "Cancelar"
    },

    // Interactive Guide
    guide: {
        title: "Guia Interativo de Analise",
        subtitle: "Explore os dados de pricing e elasticidade com consultas guiadas por funcao ou fase de analise",
        byRole: "Por Funcao",
        byPhase: "Por Fase",
        progress: "Progresso",
        completed: "concluido",
        priority: "Prioridade",
        high: "Alta",
        medium: "Media",
        low: "Baixa",
        estimatedTime: "Tempo est.",
        minutes: "min",
        runQuery: "Executar",
        running: "Executando...",
        viewFullData: "Ver dados completos",
        loadingData: "Carregando dados...",
        processingQuery: "Processando consulta...",
        close: "Fechar",
        queriesCount: "consultas",

        // Roles
        roles: {
            ceo: "CEO",
            ceoDesc: "Visao estrategica global de pricing e seu impacto na rentabilidade",
            cfo: "CFO",
            cfoDesc: "Impacto financeiro das estrategias de pricing",
            commercial: "Diretor Comercial",
            commercialDesc: "Oportunidades de crescimento e estrategias de vendas",
            revenue: "Diretor de Revenue Management",
            revenueDesc: "Otimizacao de receitas e gestao de precos dinamicos",
            marketing: "Diretor de Marketing",
            marketingDesc: "Efetividade de campanhas e estrategias de posicionamento",
            ecommerce: "Gerente de eCommerce",
            ecommerceDesc: "Performance do canal online e pricing digital",
            priceAnalyst: "Analista de Precos",
            priceAnalystDesc: "Analise detalhada de precos e posicionamento competitivo",
            elasticityAnalyst: "Analista de Elasticidade",
            elasticityAnalystDesc: "Sensibilidade de precos e analise de elasticidade de demanda"
        },

        // Phases
        phases: {
            exploration: "Exploracao de Dados",
            explorationDesc: "Entender a estrutura e distribuicao dos dados",
            descriptive: "Analise Descritiva de Pricing",
            descriptiveDesc: "Estatisticas e metricas do pricing atual",
            advanced: "Analitica Avancada",
            advancedDesc: "Analise preditiva e modelagem",
            geographic: "Analise Geografica",
            geographicDesc: "Distribuicao regional e estrategias de pricing local",
            optimization: "Otimizacao de Precos",
            optimizationDesc: "Recomendacoes e simulacao de cenarios",
            export: "Exportacao",
            exportDesc: "Gerar relatorios e exportacoes"
        }
    },

    // Reports
    reports: {
        title: "Relatorios e Analises",
        loading: "Carregando relatorio...",
        noReports: "Nao ha relatorios disponiveis",
        selectReport: "Selecione um relatorio para visualizar",
        lastUpdate: "Ultima atualizacao",
        fullscreen: "Tela cheia",
        refresh: "Atualizar",
        myFilters: "Meus Filtros",
        savedFilters: "Filtros Salvos",
        saveCurrentFilters: "Salvar Filtros Atuais",
        filterName: "Nome do filtro",
        filterNamePlaceholder: "Ex: 'Q1 2024 - Regiao Sul'",
        filterDescription: "Descricao (opcional)",
        saving: "Salvando...",
        apply: "Aplicar",
        deleteFilter: "Excluir filtro",
        noFilters: "Voce ainda nao tem filtros salvos.",
        noFiltersHint: "Ajuste os filtros do relatorio e salve-os acima.",
        filterSaved: "Filtros salvos com sucesso",
        filterApplied: "Filtros aplicados",
        filterDeleted: "Filtro excluido",
        filterError: "Erro ao salvar filtros",
        enterFilterName: "Insira um nome para o filtro",
        resetFilters: "Redefinir Filtros",
        exportPdf: "Exportar PDF",
        default: "Padrao",
        savedOn: "Salvo"
    },

    // Common
    // Redes Orgánicas (/social-organic): Instagram + Facebook + TikTok en una pantalla
    organic: {
        paidNote: "Seus anúncios somaram mais {n} visualizações neste período. Aqui você vê só o orgânico.",
        seeAds: "Ver anúncios",
        organicViews: "Visualizações orgânicas",
        organicViewsHint: "Vezes que suas publicações, reels e stories foram vistos, sem contar anúncios.",
        organicViewsFbHint: "Vezes que o conteúdo da sua página foi visto, sem contar anúncios.",
        organicInteractionsHint: "Curtidas, comentários, salvamentos e compartilhamentos no seu conteúdo, sem contar anúncios.",
        profileVisitsHintIg: "Vezes que alguém abriu seu perfil. Pode incluir visitas vindas de um anúncio.",
        netInPeriod: "{n} no período",
        statSaves: "Salvamentos",
        statSavesHint: "Pessoas que salvaram uma publicação para ver depois: um forte sinal de interesse.",
        statWebClicks: "Cliques no seu site",
        dailyFollowers: "Novos seguidores por dia",
        dailyFollowersNone: "O Instagram só compartilha este dado dos últimos 30 dias.",
        dailyFollowersPartial: "O Instagram só guarda os últimos 30 dias.",
        newFollowersWord: "novos seguidores",
        monthlyFollowers: "Seguidores por mês",
        monthlyFollowersHint: "Contas que começaram e deixaram de seguir você a cada mês, segundo a Meta. Não depende do período escolhido: sempre mostra os últimos 12 meses. O mês atual aparece mais claro porque ainda não terminou.",
        monthlyFollowersNet: "{n} líquidos em {months} meses",
        monthlyFollowersNone: "A Meta ainda não tem este dado para a conta.",
        monthlyFollowersError: "Não foi possível carregar os seguidores por mês. Tente novamente mais tarde.",
        followsWord: "Novos seguidores",
        unfollowsWord: "Deixaram de seguir",
        netWord: "Líquido",
        monthInProgress: "mês em andamento",
        formatsTitle: "Qual formato funciona melhor",
        formatsHint: "Resultados orgânicos por formato. As pessoas alcançadas são contadas por formato: quem viu um reel e um story conta nos dois.",
        formatReach: "{n} pessoas alcançadas",
        fmtREEL: "Reels",
        fmtPOST: "Publicações",
        fmtCAROUSEL: "Carrosséis",
        fmtSTORY: "Stories",
        genderF: "Mulheres",
        genderM: "Homens",
        genderU: "Não especificado",
        whereTitle: "Onde estão",
        cities: "Cidades",
        storiesSub: "Stories publicados neste período",
        storiesPublished: "Stories publicados",
        storiesAvgReach: "Alcance médio",
        storiesExitRate: "Saíram antes do fim",
        storiesExitHint: "Das vezes que alguém via seus stories, quantas vezes fechou em vez de continuar.",
        storiesNone: "Não há stories salvos deste período.",
        storiesNoneHint: "O Instagram só compartilha os stories enquanto estão ativos (24 h). A partir de agora eles são salvos todos os dias.",
        updating: "Atualizando…",
        mentionsTitle: "Mencionaram você",
        mentionsSub: "Publicações recentes de outras contas que marcaram você",
        mentionsNone: "Ninguém marcou a conta recentemente.",
        mentionsError: "Não conseguimos carregar as menções agora.",
        newFollowersPost: "Novos seguidores",
        avgWatchTime: "Tempo médio assistido",
        videoTitle: "Seus vídeos",
        videoOrganicPlays: "Reproduções orgânicas",
        video30s: "Vistos 30 s ou mais",
        video30sHint: "{pct} das reproduções orgânicas chegaram a 30 segundos.",
        reviewsTitle: "O que dizem da sua página",
        reviewsRecommend: "{pct}% recomendam você",
        reviewsCount: "{n} avaliações no total",
        reviewsNone: "Sua página ainda não tem avaliações.",
        latestReviews: "Avaliações mais recentes",
        viewers: "Pessoas",
        organicWord: "orgânico",
        title: "Redes Orgânicas",
        subtitle: "Como estão suas contas oficiais, tudo em um só lugar.",
        refresh: "Atualizar",
        updatedJustNow: "Atualizado agora mesmo",
        updatedMinutes: "Atualizado há {n} min",
        period: "Período",
        last7: "Últimos 7 dias",
        last30: "Últimos 30 dias",
        last90: "Últimos 90 dias",
        custom: "Personalizado",
        short7: "7 dias",
        short30: "30 dias",
        short90: "90 dias",
        customShort: "Datas",
        showing: "{from} – {to}",
        pickDates: "Escolha a data de início e de fim",
        from: "De",
        to: "Até",
        tabNotConnected: "Não conectado",
        tabError: "Não foi possível carregar",
        tabLoading: "Carregando…",
        followersShort: "{n} seguidores",
        notConnectedTitle: "{network} ainda não está conectado",
        notConnectedBody: "Um administrador precisa conectar esta conta para que os números apareçam aqui.",
        goToIntegrations: "Ir para Integrações",
        errorTitle: "Não conseguimos carregar os números",
        errorBody: "Geralmente é temporário. Tente novamente em instantes.",
        retry: "Tentar novamente",
        demoNote: "Conta de demonstração: estes números são de exemplo.",
        partialData: "Alguns números não estão disponíveis agora e aparecem como —.",
        periodLast: "Últimos {n} dias",
        periodCapped: "Últimos {n} dias (máximo disponível)",
        periodRange: "{from} – {to}",
        today: "Hoje",
        followers: "Seguidores",
        followersHint: "Pessoas que seguem a conta hoje.",
        reach: "Alcance",
        reachHint: "Pessoas diferentes que viram seu conteúdo no período.",
        views: "Visualizações",
        viewsHint: "Total de vezes que seu conteúdo foi visto. Uma pessoa pode contar várias vezes.",
        profileVisits: "Visitas ao perfil",
        profileVisitsHint: "Vezes que alguém abriu seu perfil.",
        pageVisits: "Visitas à página",
        pageVisitsHint: "Vezes que alguém abriu sua página do Facebook.",
        interactions: "Interações",
        interactionsHintFb: "Reações, comentários, compartilhamentos e cliques nas suas publicações.",
        interactionsHintTt: "Curtidas, comentários e compartilhamentos nos seus vídeos.",
        videoViews: "Visualizações de vídeo",
        videoViewsHint: "Vezes que seus vídeos foram reproduzidos.",
        netFollowers: "Novos seguidores",
        netFollowersHint: "Seguidores ganhos menos os perdidos no período.",
        gainedLost: "{gained} ganhos · {lost} perdidos",
        postsCount: "{n} publicações no total",
        videosCount: "{n} vídeos no total",
        peopleCount: "{n} pessoas",
        summaryTitle: "Resumo do período",
        statPosts: "Publicações no período",
        statVideos: "Vídeos no período",
        statAvg: "Interações médias por publicação",
        statAvgVideo: "Interações médias por vídeo",
        statBestType: "O conteúdo que funciona melhor",
        statInterPerView: "Interação por visualização",
        engagement: "Engajamento",
        engagementHint: "Interações médias por publicação do período divididas pelos seus seguidores. É calculado da mesma forma no Instagram, Facebook e TikTok, então serve para comparar redes e contas de tamanhos diferentes.",
        engagementSub: "Por publicação · {n} no período",
        engagementSubVideos: "Por vídeo · {n} no período",
        engagementNone: "Sem publicações no período",
        engagementNoneVideos: "Sem vídeos no período",
        statEngagementTtHint: "Interações divididas pelas visualizações dos seus vídeos. Quanto maior, mais quem assiste responde.",
        statShares: "Vezes compartilhado",
        statVideoViews: "Visualizações destes vídeos",
        bestPost: "Publicação destaque do período",
        bestVideo: "Vídeo destaque do período",
        nInteractions: "{n} interações",
        nViews: "{n} visualizações",
        seeDetail: "Ver detalhes",
        chartInterByPost: "Interações por publicação",
        chartInterByVideo: "Interações por vídeo",
        byDate: "por data",
        chartTypeMix: "Qual conteúdo gera mais interação",
        chartTopPosts: "Melhores publicações",
        chartTopVideos: "Vídeos mais vistos",
        chartReachByType: "Alcance por tipo de conteúdo",
        chartReachByTypeHint: "Quantas pessoas cada tipo de publicação alcançou desde que foi publicada. Soma publicações, então a mesma pessoa pode contar mais de uma vez.",
        reachAccum: "alcance total",
        reachNone: "Não há dados de alcance para estas publicações.",
        fbDaily: "Atividade da página por dia",
        fbReactions: "Como as pessoas reagiram",
        fbReactionsHint: "Todas as reações que sua página recebeu no período, inclusive em publicações antigas.",
        fbReactionsNone: "Sem reações neste período.",
        reactionsWord: "reações",
        interactionsWord: "interações",
        nPostsShort: "{n} publ.",
        nDays: "{n} dias",
        likes: "Curtidas",
        comments: "Comentários",
        shares: "Compartilhamentos",
        clicks: "Cliques",
        reactions: "Reações",
        visits: "Visitas",
        audienceTitle: "Sua audiência",
        audienceSub: "Quem segue sua conta do Instagram",
        gender: "Gênero",
        age: "Idade",
        ofFollowers: "% de seguidores",
        topCities: "Principais cidades",
        countries: "Países",
        followerGrowth: "Crescimento de seguidores",
        monthly: "por mês",
        stories: "Stories",
        storiesCount: "{n} stories",
        replies: "Respostas",
        retention: "Retenção",
        exits: "Saídas",
        reels: "Reels",
        reelsCount: "{n} reels",
        plays: "Reproduções",
        avgWatch: "Tempo médio",
        saves: "Salvamentos",
        profileActions: "Ações no seu perfil",
        website: "Site",
        whatsapp: "WhatsApp",
        directions: "Como chegar",
        calls: "Ligações",
        postsTitle: "Publicações",
        videosTitle: "Vídeos",
        gridView: "Grade",
        tableView: "Tabela",
        sortRecent: "Mais recentes",
        sortTop: "Mais interações",
        sortViews: "Mais visualizações",
        emptyPosts: "Nenhuma publicação neste período.",
        emptyVideos: "Nenhum vídeo neste período.",
        emptyHint: "Tente um período maior para ver mais.",
        seeLast30: "Ver últimos 30 dias",
        seeLast90: "Ver últimos 90 dias",
        clearDayFilter: "Remover filtro de dia",
        noCaption: "Sem legenda",
        colPost: "Publicação",
        colVideo: "Vídeo",
        colDate: "Data",
        colType: "Tipo",
        colInter: "Interações",
        colViews: "Visualizações",
        typeImage: "Imagem",
        typeVideo: "Vídeo",
        typeCarousel: "Carrossel",
        typeReel: "Reel",
        typePhoto: "Foto",
        typeAlbum: "Álbum",
        typeLink: "Link",
        typeEvent: "Evento",
        typeStatus: "Texto",
        typeOther: "Outro",
        rxLike: "Curtir",
        rxLove: "Amei",
        rxCare: "Força",
        rxHaha: "Haha",
        rxWow: "Uau",
        rxSorry: "Triste",
        rxAnger: "Grr",
        rxThankful: "Gratidão",
        rxPride: "Orgulho",
        close: "Fechar",
        viewOn: "Ver no {network}",
        commentsTitle: "Comentários",
        loadComments: "Carregar comentários",
        reloadComments: "Recarregar",
        loadingComments: "Carregando…",
        noComments: "Esta publicação não tem comentários.",
        commentsError: "Não foi possível carregar os comentários.",
        userFallback: "usuário"
    },

    common: {
        loading: "Carregando...",
        error: "Erro",
        success: "Sucesso",
        confirm: "Confirmar",
        cancel: "Cancelar",
        save: "Salvar",
        saving: "Salvando...",
        delete: "Excluir",
        edit: "Editar",
        add: "Adicionar",
        search: "Buscar",
        filter: "Filtrar",
        clear: "Limpar",
        close: "Fechar",
        back: "Voltar",
        next: "Proximo",
        yes: "Sim",
        no: "Nao",
        ok: "OK",
        noData: "Nao ha dados disponiveis",
        required: "Obrigatorio",
        optional: "Opcional"
    },

    // User Profile
    profile: {
        title: "Perfil do Usuario",
        email: "E-mail",
        organization: "Organizacao",
        role: "Funcao",
        plan: "Plano",
        features: "Funcionalidades",
        logout: "Sair",
        settings: "Configuracoes"
    },

    // Floating Chat
    floatingChat: {
        title: "CLIA Agent",
        welcome: "Ola! Sou **CLIA**, seu assistente inteligente. Posso ajuda-lo a consultar informacoes do datalake, analisar precos de concorrentes e gerar insights.\n\n**Funcoes disponiveis:**\n- Analise de dados\n- Analise de imagens (graficos, tabelas, etc.)\n- Processamento de arquivos Excel\n- Analise de documentos PDF\n\nO que voce gostaria de saber?",
        cleared: "Chat limpo. Sou **CLIA**, seu assistente inteligente. Como posso ajuda-lo?",
        save: "Salvar conversa",
        expand: "Expandir",
        restore: "Restaurar tamanho",
        clear: "Limpar chat",
        minimize: "Minimizar",
        attach: "Anexar arquivo",
        screenshot: "Capturar tela",
        analyzing: "Analisando...",
        // Screenshot guide
        screenshotGuideTitle: "Captura de Tela",
        screenshotGuideText: "Aparecera um dialogo do navegador para selecionar o que deseja compartilhar.",
        screenshotStep1: "Selecione \"Esta aba\" no dialogo",
        screenshotStep2: "Clique em \"Compartilhar\" para capturar",
        screenshotStep3: "Adicione sua pergunta e envie",
        cancel: "Cancelar",
        continueCapture: "Continuar"
    },

    // Errors
    errors: {
        generic: "Ocorreu um erro. Por favor, tente novamente.",
        network: "Erro de rede. Verifique sua conexao.",
        unauthorized: "Nao autorizado. Por favor, faca login novamente.",
        notFound: "Recurso nao encontrado.",
        serverError: "Erro do servidor. Por favor, tente mais tarde."
    },

    // Terms and Conditions
    tyc: {
        title: "Termos e Condicoes",
        sections: [
            {
                title: "1. Introducao",
                content: "Estes Termos e Condicoes regem o uso do Balance Score Card Digital. Ao utilizar este servico, voce concorda em cumprir todas as condicoes aqui descritas. Observe que os precos sugeridos sao apenas um guia e devem ser validados pelo usuario final."
            },
            {
                title: "2. Uso do Servico",
                content: "O assistente fornece recomendacoes baseadas em dados. Embora se esforce para ser preciso, nao garantimos a exatidao absoluta dos resultados. Os precos sugeridos devem ser considerados como um guia e e responsabilidade do usuario final valida-los antes de sua implementacao."
            },
            {
                title: "3. Privacidade e Seguranca",
                content: "A privacidade e seguranca dos seus dados sao herdadas dos SLAs, regras e politicas de seguranca da AWS e dos servicos utilizados na arquitetura do agente, como S3, Lambda, PostgreSQL e Bedrock. Alem disso, os dados coletados atraves do assistente sao utilizados exclusivamente para melhorar a precisao das recomendacoes. Nao compartilhamos seus dados com terceiros sem seu consentimento explicito."
            },
            {
                title: "4. Limitacoes de Responsabilidade",
                content: "Nao seremos responsaveis por perdas ou danos decorrentes do uso do assistente. O usuario final e responsavel por validar os precos sugeridos antes de tomar decisoes comerciais."
            },
            {
                title: "5. Modificacoes",
                content: "Reservamo-nos o direito de modificar estes termos a qualquer momento. As modificacoes serao efetivas a partir do momento de sua publicacao nesta pagina."
            },
            {
                title: "6. Contato",
                content: "Para qualquer duvida ou esclarecimento sobre estes termos, voce pode entrar em contato conosco atraves do seu Assessor."
            }
        ]
    },

    // FAQ
    faq: {
        title: "Perguntas Frequentes sobre o Balance Score Card Digital",
        questions: [
            {
                question: "O que e o Balance Score Card Digital?",
                answer: "E uma ferramenta impulsionada por inteligencia artificial que ajuda a otimizar a estrategia de precos dos seus produtos, analisando vendas, margens, precos da concorrencia e outros fatores-chave. Lembre-se de que os precos sugeridos sao apenas um guia e devem ser validados pelo usuario final."
            },
            {
                question: "Que tipo de dados sao utilizados?",
                answer: "Utilizamos dados como data de venda, identificadores de produtos (SKU), unidades vendidas, precos finais, margens e outros parametros relacionados a concorrencia e localizacoes geograficas."
            },
            {
                question: "Como e garantida a precisao dos precos recomendados?",
                answer: "O assistente utiliza modelos de machine learning que sao constantemente treinados com dados atualizados para oferecer recomendacoes precisas e baseadas em evidencias. No entanto, voce deve sempre validar as recomendacoes antes de implementa-las."
            },
            {
                question: "Como a privacidade dos meus dados e protegida?",
                answer: "A privacidade e seguranca dos seus dados sao nossa prioridade. Estas sao herdadas dos SLAs, regras e politicas de seguranca da AWS e dos servicos que utilizamos na arquitetura do assistente, como S3, Lambda, PostgreSQL e Bedrock. Alem disso, sao gerenciados de acordo com as leis e regulamentacoes vigentes, utilizando criptografia e outras medidas de seguranca avancadas."
            },
            {
                question: "Posso personalizar as recomendacoes de precos?",
                answer: "Sim, voce pode ajustar os parametros e criterios que o assistente utiliza para que as recomendacoes se adaptem melhor as suas necessidades especificas. Mesmo assim, os precos sugeridos devem ser validados antes de aplica-los."
            }
        ]
    },

    // Guide Queries - Roles
    guideQueries: {
        roles: {
            ceo: {
                title: "CEO",
                description: "Visao estrategica global de pricing e seu impacto na rentabilidade",
                queries: [
                    { text: "Mostre-me um resumo executivo com os KPIs de pricing mais importantes e seu impacto na rentabilidade global", category: "resumo" },
                    { text: "Qual e o impacto financeiro das nossas estrategias de pricing vs concorrencia?", category: "concorrencia" },
                    { text: "Analise de tendencias de vendas por regiao e categoria nos ultimos 6 meses", category: "tendencias" }
                ]
            },
            cfo: {
                title: "CFO",
                description: "Impacto financeiro das estrategias de pricing",
                queries: [
                    { text: "Impacto financeiro das estrategias de pricing otimizadas por IA", category: "financeiro" },
                    { text: "Analise de sensibilidade de precos e seu efeito na margem de contribuicao", category: "sensibilidade" },
                    { text: "Projecoes financeiras baseadas em diferentes cenarios de pricing", category: "projecoes" }
                ]
            },
            commercial: {
                title: "Diretor Comercial",
                description: "Oportunidades de crescimento e estrategias de vendas",
                queries: [
                    { text: "Quais sao as principais oportunidades de crescimento identificadas nos dados?", category: "oportunidades" },
                    { text: "Analise de elasticidade de precos por segmento de cliente e canal de vendas", category: "elasticidade" },
                    { text: "Recomendacoes de promocoes cruzadas para maximizar o valor do cliente", category: "promocoes" },
                    { text: "Desempenho de vendas por canal e regiao com tendencias", category: "desempenho" }
                ]
            },
            revenue: {
                title: "Diretor de Revenue Management",
                description: "Otimizacao de receitas e gestao de precos dinamicos",
                queries: [
                    { text: "Dashboard de performance de pricing com alertas e recomendacoes", category: "dashboard" },
                    { text: "Analise da efetividade das regras de pricing implementadas", category: "efetividade" },
                    { text: "Simulacao de cenarios de guerra de precos e estrategias de resposta", category: "simulacao" }
                ]
            },
            marketing: {
                title: "Diretor de Marketing",
                description: "Efetividade de campanhas e estrategias de posicionamento",
                queries: [
                    { text: "Analise da efetividade de campanhas de marketing em relacao as estrategias de pricing", category: "campanhas" },
                    { text: "Recomendacoes de precos para novos lancamentos de produtos", category: "lancamentos" },
                    { text: "Segmentacao de clientes baseada em sensibilidade ao preco e comportamento de compra", category: "segmentacao" }
                ]
            },
            ecommerce: {
                title: "Gerente de eCommerce",
                description: "Otimizacao do canal digital",
                queries: [
                    { text: "Otimizacao de precos em tempo real para o canal online", category: "online" },
                    { text: "Analise de comportamento de compra em relacao aos precos", category: "comportamento" },
                    { text: "Estrategias de pricing personalizadas para diferentes segmentos de clientes online", category: "personalizacao" }
                ]
            },
            priceAnalyst: {
                title: "Analista de Precos",
                description: "Analise detalhada e modelagem de precos",
                queries: [
                    { text: "Ferramentas de modelagem preditiva para analise de cenarios de precos", category: "modelagem" },
                    { text: "Relatorios detalhados de elasticidade de precos por SKU e categoria", category: "elasticidade" },
                    { text: "Alertas automaticos de anomalias em precos ou comportamento de compra", category: "anomalias" },
                    { text: "Me de uma tabela com os top 20 produtos por margem de contribuicao", category: "top_produtos" }
                ]
            },
            categories: {
                title: "Diretor de Categorias",
                description: "Gestao de portfolio e otimizacao de categorias",
                queries: [
                    { text: "Analise de contribuicao para a margem por produto, categoria e cliente", category: "contribuicao" },
                    { text: "Otimizacao da estrutura de descontos e promocoes", category: "descontos" },
                    { text: "Identificacao de oportunidades de melhoria na rentabilidade por categoria", category: "rentabilidade" }
                ]
            }
        },
        phases: {
            eda: {
                title: "Exploracao de Dados (EDA)",
                description: "Analise exploratoria inicial dos dados disponiveis",
                queries: [
                    { text: "Me de uma tabela com as principais tendencias de vendas por categoria", category: "tendencias" },
                    { text: "Quais sao as colunas e metricas disponiveis nos dados?", category: "estrutura" },
                    { text: "Resumo estatistico dos dados de precos e vendas", category: "estatisticas" },
                    { text: "Qual periodo de tempo os dados disponiveis cobrem?", category: "periodo" }
                ]
            },
            pricing: {
                title: "Analise Descritiva de Pricing",
                description: "Analise detalhada das estrategias de precos atuais",
                queries: [
                    { text: "Distribuicao de precos por categoria e concorrente", category: "distribuicao" },
                    { text: "Analise de gaps de preco vs concorrencia por categoria", category: "gaps" },
                    { text: "Evolucao historica de precos por produto e marca", category: "evolucao" },
                    { text: "Comparativo de margens por canal de vendas", category: "margens" }
                ]
            },
            elasticity: {
                title: "Analitica Avancada de Elasticidade",
                description: "Analise de sensibilidade de precos e elasticidade de demanda",
                queries: [
                    { text: "Calculo de elasticidade preco-demanda por categoria", category: "elasticidade" },
                    { text: "Produtos com maior sensibilidade ao preco", category: "sensibilidade" },
                    { text: "Impacto de mudancas de preco no volume de vendas", category: "impacto" },
                    { text: "Correlacao entre preco e participacao de mercado", category: "correlacao" }
                ]
            },
            geographic: {
                title: "Analise Geografica e Competitividade",
                description: "Analise por regiao e posicionamento competitivo",
                queries: [
                    { text: "Desempenho de vendas por regiao geografica", category: "regional" },
                    { text: "Analise de competitividade de precos por zona", category: "competitividade" },
                    { text: "Oportunidades de mercado por localizacao", category: "oportunidades" }
                ]
            },
            optimization: {
                title: "Otimizacao de Precos",
                description: "Recomendacoes de otimizacao baseadas em analise",
                queries: [
                    { text: "Recomendacoes de ajuste de precos para maximizar margem", category: "recomendacoes" },
                    { text: "Simulacao de impacto de mudancas de preco", category: "simulacao" },
                    { text: "Estrategia otima de pricing por segmento", category: "estrategia" },
                    { text: "ROI esperado das otimizacoes propostas", category: "roi" }
                ]
            },
            export: {
                title: "Exportacao de Recomendacoes",
                description: "Geracao de relatorios e exportacao de dados",
                queries: [
                    { text: "Gere um relatorio executivo com as principais metricas", category: "relatorio" },
                    { text: "Lista de produtos com recomendacao de mudanca de preco", category: "lista" },
                    { text: "Resumo das principais descobertas para apresentacao", category: "descobertas" }
                ]
            }
        }
    },

    // MFA / TOTP setup
    mfa: {
        title: "Autenticacao de dois fatores (MFA)",
        loading: "Carregando configuracao...",
        scanInstructions: "Escaneie o codigo QR com seu app de autenticacao (Google Authenticator, Authy, Microsoft Authenticator, 1Password, etc.).",
        cantScan: "Nao consegue escanear o QR?",
        manualSecret: "Insira este codigo manualmente em seu app de autenticacao:",
        copy: "Copiar",
        copied: "Copiado",
        next: "Proximo",
        back: "Voltar",
        cancel: "Cancelar",
        close: "Fechar",
        retry: "Tentar novamente",
        enterCode: "Insira o codigo de 6 digitos que aparece no seu app de autenticacao:",
        verify: "Verificar",
        verifying: "Verificando...",
        processing: "Processando...",
        successTitle: "MFA ativado!",
        successDesc: "Da proxima vez que entrar pediremos o codigo de 6 digitos do seu app de autenticacao.",
        nextLogin: "Voce precisara do seu app de autenticacao toda vez que entrar.",
        alreadyEnabled: "MFA ja esta ativado em sua conta",
        alreadyEnabledDesc: "Voce esta usando um app de autenticacao. Pode reconfigura-lo (por exemplo, ao trocar de dispositivo) ou remove-lo completamente.",
        reconfigure: "Reconfigurar MFA",
        remove: "Remover MFA",
        removeConfirmTitle: "Remover MFA?",
        removeConfirmDesc: "Sua conta deixara de ter autenticacao de dois fatores. Qualquer pessoa com sua senha podera entrar. Voce pode reativar o MFA quando quiser.",
        confirmRemove: "Sim, remover",
        removedTitle: "MFA removido",
        removedDesc: "Nao pediremos mais um codigo de autenticacao ao entrar. Recomendamos reativar o MFA quando possivel.",
        errorGeneric: "Ocorreu um erro. Tente novamente.",
        errorInvalidCode: "Codigo invalido. Verifique o codigo no seu app de autenticacao e tente novamente."
    },

    // Custom Reports (editor)
    report: {
        loading: "Carregando relatório…",
        titlePlaceholder: "Título do relatório",
        saving: "Salvando…",
        exportPdf: "PDF",
        exportPdfTitle: "Exportar para PDF (Imprimir → Salvar como PDF)",
        deleteReport: "Excluir",
        deleteConfirm: "Excluir este relatório? Não pode ser desfeito.",
        empty: "Este relatório está vazio.",
        emptyHint: "Adicione blocos pela barra abaixo, ou vá ao chat e use o botão \"Salvar no relatório\" em qualquer mensagem.",
        addBlockLabel: "+ Adicionar bloco:",
        blockHeading: "Título",
        blockText: "Texto",
        blockDivider: "Separador",
        newHeading: "Novo título",
        newText: "Escreva aqui…",
        emptyPlaceholder: "*Vazio — clique para editar*",
        botMessageLabel: "Resposta do agente",
        clientMessageLabel: "Pergunta",
        moveUp: "Mover acima",
        moveDown: "Mover abaixo",
        delete: "Excluir",
        untitledHeading: "Sem título",
        markdownPlaceholder: "Escreva em markdown…",
        blockChartAlt: "Gráfico",
        chartCaptionPlaceholder: "Legenda do gráfico (opcional)",
        placeholder: "Comece a escrever, ou use os botões acima para inserir elementos…",
        savedJustNow: "Salvo",
        toolbar: {
            heading: "Estilo de texto",
            paragraph: "Parágrafo",
            h1: "Título 1",
            h2: "Título 2",
            h3: "Título 3",
            insertTable: "Inserir tabela",
            deleteTable: "Excluir tabela"
        }
    }
};

export default pt;
